import { render, staticRenderFns } from "./OTD.vue?vue&type=template&id=125c2c5a"
import script from "./OTD.vue?vue&type=script&lang=js"
export * from "./OTD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports